/* 
  教师名单维护
*/
import request from "@/utils/request";
let baseUrl1 = window.config.baseUrl4Print  // 梁江辉接口地址1
let baseUrl2 = window.config.baseUrl2  // 飞泉接口地址online


//获取教师信息管理分页列表  /baseinfo/maintain/getTchInfoMaintainList
export function getTeacherMaintain(params) {
  return request({
    url: "/baseinfo/maintain/getTchInfoMaintainList",
    method: "get",
    params
  });
}
//获取教师信息管理页面参数  /baseinfo/maintain/getParam
export function getTeacherMaintainParam() {
  return request({
    url: "/baseinfo/maintain/getParam",
    method: "get",
  });
}
//教师总人数/有效人数  /baseinfo/maintain/validTeacherNum
export function validTeacherNum() {
  return request({
    url:"/baseinfo/maintain/validTeacherNum",
    method: "get"
  });
}

//加入黑名单  /baseinfo/maintain/addBlackList
export function addBlackList(data) {
    return request({
      url: "/baseinfo/maintain/addBlackList",
      method: "post",
      data
    });
  }

  // 重置密码  /baseinfo/maintain/resetPasswords
export function resetPasswords(data) {
  return request({
    url: "/baseinfo/maintain/resetPasswords",
    method: "post",
    data
  });
}
  
  //移出黑名单 /baseinfo/maintain/removeBlackList
  export function removeBlackList(data) {
    return request({
      url:"/baseinfo/maintain/removeBlackList",
      method: "post",
      data
    });
  }
//   todo 暂无接口
//保存或编辑教师信息
export function saveOrUpdate(data) {
  return request({
    url: "/baseinfo/maintain/editBaseInfo",
    method: "post",
    data
  });
}
//   todo 暂无接口
//删除教师信息
export function deleteTeacherMaintain(data) {
  return request({
    url: "/baseinfo/teacherinfo/deleteTeacherInfo",
    method: "post",
    data
  });
}


//标记是否有效 /baseinfo/maintain/markValid
export function markValid(data) {
  return request({
    url:"/baseinfo/maintain/markValid",
    method: "post",
    data
  });
}

//激活账号 /baseinfo/maintain/activateAccount
export function activateAccount(data) {
  return request({
    url:"/baseinfo/maintain/activateAccount",
    method: "post",
    data
  });
}


//发送短信息
export function sendMessageTeacherMaintain(data) {
  return request({
    url:"/baseinfo/maintain/sendMessage",
    method: "post",
    data
  });
}

//发送通知 /baseinfo/maintain/sendInform
export function sendNoticeTeacherMaintain(data) {
  return request({
    url:"/baseinfo/maintain/sendInform",
    method: "post",
    data
  });
}
//   todo 暂无接口
//查看教师详情信息
export function getTeacherDetailInfo(params) {
  return request({
    url: "/baseinfo/teacherinfo/getTeacherDetailInfo",
    method: "get",
    params
  });
}

// 获取短信教师名单
export function getMsgTeacher(params: Object) {
  return request({
    url: "/baseinfo/maintain/getMsgTeacher",
    method: "get",
    params
  });
}
